import { Component, Input, Output, EventEmitter } from '@angular/core';
var SearchTabsComponent = /** @class */ (function () {
    function SearchTabsComponent() {
        /**
         * @type tabChange {EventEmitter<ISearchResultTabModel>} - tab has clicked
         */
        this.tabChange = new EventEmitter();
    }
    SearchTabsComponent.prototype.getTabHeading = function (resultTab) {
        var tabText = resultTab.tab.heading.text;
        if (!resultTab.error) {
            if (resultTab.tab.disableCounter) {
                tabText = "" + tabText;
            }
            else {
                tabText = tabText + " (" + (resultTab.totalCount || 0) + ")";
            }
        }
        return tabText;
    };
    SearchTabsComponent.prototype.tabClick = function (resultTab) {
        this.resultTabs.forEach(function (t) { return (t.active = false); });
        resultTab.active = true;
        this.tabChange.emit(resultTab);
    };
    SearchTabsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-search-tabs',
                    template: "<div class=\"m-search-tabs\">\r\n\t<div class=\"m-search-tabs__bg-line\"></div>\r\n\t<ul class=\"m-search-tabs__list\" data-t-name=\"SearchTabs\">\r\n\t\t<li\r\n\t\t\tclass=\"m-search-tabs__tab\"\r\n\t\t\t[ngClass]=\"{'m-search-tabs__tab--active' : resultTab.active}\"\r\n\t\t\t(click)=\"tabClick(resultTab)\"\r\n\t\t\t*ngFor=\"let resultTab of resultTabs\"\r\n\t\t>\r\n\t\t\t<span [innerHTML]=\"getTabHeading(resultTab)\"></span>\r\n\t\t</li>\r\n\t</ul>\r\n</div>\r\n"
                }] }
    ];
    SearchTabsComponent.propDecorators = {
        resultTabs: [{ type: Input }],
        tabChange: [{ type: Output }]
    };
    return SearchTabsComponent;
}());
export { SearchTabsComponent };
//# sourceMappingURL=search-tabs.component.js.map